<template>
  <div>
    <div class="search-page">

      <div class="search-container">

        <div class="portal-header">

          <h2>CASUAL LABOURER MANAGEMENT SYSTEM</h2>
          <h4>Labourer Information Search Page</h4>
        </div>

        <md-card class="search-card">

          <md-card-header class="search-card-header">
            <p>
              Enter NIDA Number and Phone Number to get your shift Schedule assigned.<br>
              (At-list first 8 digits of NIDA Number)
            </p>
          </md-card-header>

          <md-card-content>

            <md-field
                :class="{ 'md-invalid': apiValidationErrors.nida }"
            >
              <md-icon>badge</md-icon>
              <label>NIDA Number (at-least 8 first digits):</label>

              <md-input
                  v-model="nida"
                  type="text"
              />

              <validation-error
                  :errors="apiValidationErrors.nida"
              />
            </md-field>

            <md-field
                :class="{ 'md-invalid': apiValidationErrors.phone }"
            >
              <md-icon>phone</md-icon>
              <label>Phone Number:</label>

              <md-input
                  v-model="phone"
                  type="text"
              />

              <validation-error
                  :errors="apiValidationErrors.phone"
              />
            </md-field>

          </md-card-content>

          <md-card-actions>
            <md-button
                class="md-raised md-primary search-btn"
                @click="search"
                :disabled="loading"
            >
              <md-icon>search</md-icon>
              Search Info
            </md-button>
            <md-progress-bar
                v-if="loading"
                md-mode="indeterminate">
            </md-progress-bar>
          </md-card-actions>

        </md-card>
        <md-card
            v-if="labourer"
            class="result-card">

          <md-card-header class="result-header">
            <h3>
              Hello:
              {{ labourer.first_name }}
              {{ labourer.middle_name }}
              {{ labourer.last_name }}
            </h3>

            <md-button
                class="md-raised md-primary"
                @click="daysBack"
                :disabled="loading"
            >
              <md-icon>history</md-icon>
              7 Days Back
            </md-button>
          </md-card-header>

          <md-card-content>
            <div
                class="schedule-block"
                v-if="!labourer.labourer_schedules.length"
            >
              <p class="mb-0">
                <i class="fas fa-info-circle text-info"></i>
                No active assignments are available at the moment.
              </p>
            </div>
            <div
                v-for="(slabourer, index) in labourer.labourer_schedules"
                :key="slabourer.id || index"
                class="schedule-block"
            >
              <div class="schedule-title">
                <md-icon>event</md-icon>
                <span>Schedule #{{ index + 1 }}</span>
              </div>

              <div class="result-grid">

                <div class="result-item">
                  <strong>TakeOn:</strong>
                  <span>{{ slabourer.takeon_number }}</span>
                </div>

                <div class="result-item">
                  <strong>Date:</strong>
                  <span>{{ formatDate(slabourer.schedule.shift_date) }}</span>
                </div>

                <div class="result-item">
                  <strong>Shift:</strong>
                  <span>
        {{
                      slabourer.schedule && slabourer.schedule.shift
                          ? slabourer.schedule.shift.name
                          : '-'
                    }}
      </span>
                </div>

                <div class="result-item">
                  <strong>Time:</strong>
                  <span>
                 {{ formatDateTime(slabourer.schedule.start_time) }}
                   -
                  {{ formatDateTime(slabourer.schedule.end_time) }}
      </span>
                </div>

                <div class="result-item">
                  <strong>Work Place:</strong>
                  <span>
        {{ slabourer.workplace ? slabourer.workplace.name : '-' }}
      </span>
                </div>

                <div class="result-item">
                  <strong>Activity:</strong>
                  <span>
        {{ slabourer.activity ? slabourer.activity.name : '-' }}
      </span>
                </div>

              </div>
            </div>
            <div class="portal-footer">
              © {{ currentYear }}
              {{ vendorName }}
              | Authorized Casual Labour Service Provider at
              {{ portName }}.
            </div>

          </md-card-content>
        </md-card>
        <md-card
            v-if="searched &&!labourer && !loading && Object.keys(apiValidationErrors || {}).length === 0 "
            class="result-card">

          <md-card-content class="text-center">

            <md-icon
                style="font-size:60px;color:#f44336">
              search_off
            </md-icon>

            <h3>Record Not Found</h3>
            <div class="schedule-block">
              <p class="mb-0">
                <i class="fas fa-info-circle text-info"></i>
                No search result found from your NIDA and Phone entered
              </p>
            </div>

          </md-card-content>

        </md-card>

      </div>
    </div>
  </div>
</template>

<script>
import {ValidationError} from '@/components';
import formMixin from '@/mixins/form-mixin';
import labourerService from '@/store/services/vendors/labourers-service';

export default {
  name: 'LabourerSearch',

  components: {
    ValidationError
  },

  mixins: [formMixin],

  data() {
    return {
     // nida: '20000716394120000225',
     // phone: '0656214148',
       nida:'',
      phone:'',
      days: 0,
      loading: false,
      labourer: null,
      searched: false
    };
  },
computed:{
  currentYear() {
    return new Date().getFullYear();
  },
  vendorName () {
    if (!this.labourer.vendor || !this.labourer.vendor.length) {
      return '';
    }

    return this.labourer.vendor[0].short_name ||
        this.labourer.vendor[0].name;
  },

  portName () {
    return this.labourer.port
        ? this.labourer.port.name
        : '';
  }
},
  methods: {
    daysBack() {
      this.days = 30;
      this.search()
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      });
    },
    formatDateTime(date) {
      if (!date) return '';

      return new Intl.DateTimeFormat('en-GB', {
        //  day: '2-digit',
        //  month: 'short',
        //  year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).format(new Date(date));
    },
    async search() {
      this.loading = true;
      this.labourer = null;
      this.searched = false;
      this.apiValidationErrors = {};

      try {
        const response = await labourerService.searchByNidaAndPhone({
          nida: this.nida,
          phone: this.phone,
          days: this.days
        });

        this.labourer = response.data;
        this.searched = true;

      } catch (error) {

        this.searched = true;
        this.labourer = null;

        if (error.response && error.response.status === 422) {

          this.apiValidationErrors =
              error.response.data.errors || {};

          if (this.setApiValidation) {
            this.setApiValidation(
                error.response.data.errors || {}
            );
          }

          return;
        }

        if (error.response && error.response.status !== 404) {
          console.error(error);
        }

      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.search-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  justify-content: center;
  align-items: flex-start;

  overflow-y: auto;

  background: linear-gradient(
      135deg,
      #1353aa 50%,
      #1565c0 50%,
      #42a5f5 100%
  );

  padding: 20px;
}

.search-container {
  width: 100%;
  max-width: 650px;
  margin-top: 40px;
  margin-bottom: 30px;
}

.portal-header {
  text-align: center;
  color: white;
  margin-bottom: 20px;
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.result-header h3 {
  margin: 0;
}

/* Mobile */
@media (max-width: 768px) {
  .result-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

.portal-header h2 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
}

.portal-header h4 {
  margin: 5px 0;
}

.portal-header p {
  margin-top: 10px;
}

.search-card {
  border-radius: 15px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, .15);
}

.result-card {
  margin-top: 20px;
  border-radius: 15px;
}

.result-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.result-item {
  display: flex;
  flex-direction: column;
}

.result-item strong {
  color: #1565c0;
  margin-bottom: 5px;
}

.result-item span {
  color: #444;
}

@media (max-width: 768px) {
  .result-grid {
    grid-template-columns: 1fr;
  }
}

.floating-login {
  position: fixed;
  top: 20px;
  right: 20px;

  z-index: 99999999 !important;

  /* CRITICAL: detach from layout stacking context */
  isolation: isolate;
}

.login-link {
  all: unset !important; /* 🔥 removes hidden inherited MD styles */

  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999 !important;
  padding: 1px 14px !important;
  border-radius: 8px;

  background: #FFF !important;
  color: #6a1b9a !important;

  font-size: 14px;
  font-weight: 500;

  cursor: pointer !important;
  pointer-events: auto !important;
  text-decoration: none;

  transition: 0.2s ease;
}

.login-link:hover {
  background: rgba(0, 0, 0, 0.7);
  transform: translateY(-1px);
}

.top-bar {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
}

.login-link {
  padding: 8px 14px;
  border-radius: 6px;
  background: #00000055;
  color: white;
  text-decoration: none;
}

.schedule-block {
  padding: 15px 0;
  border-bottom: 1px solid #e0e0e0;
}

.schedule-block:last-child {
  border-bottom: none;
}

.schedule-block h4 {
  margin-bottom: 12px;
  color: #1565c0;
}

.schedule-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 12px 16px;
  margin-bottom: 15px;

  background: linear-gradient(135deg, #1565c0, #42a5f5);
  color: white;

  border-radius: 10px;
  font-weight: 700;
}

.schedule-title .md-icon {
  margin-right: 8px;
  margin-left: 0;
  color: white !important;
  flex-shrink: 0;
}

.schedule-block {
  margin-bottom: 20px;
  padding: 15px;

  background: #f8fbff;

  border-left: 5px solid #1565c0;
  border-radius: 10px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, .05);
}
.portal-footer {
  margin-top: 20px;
  text-align: center;
  color:#6a1b9a;
  font-size: 12px;
  line-height: 1.5;
}
</style>
